import { title } from "../global";
import { useLocation } from "react-router-dom";

export default function Navbar(props) {
    const location = useLocation();
    const isUsersPage = location.pathname === '/users';

    return (<div className='navbar'>
        <div className='navbar-title' Style={'display: flex; align-items: center; gap: 20px;'}>
            <a href="/" Style={'color: white; text-decoration: none;'}>{title}</a>
            {isUsersPage && (
                <a href="/" Style={'color: rgba(255,255,255,0.8); text-decoration: none; font-size: 14px; font-weight: normal;'}>
                    ← Back to Home
                </a>
            )}
        </div>
    </div>)
}
